module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/collapse-arrows-d0e657b81956d78e0e4a746bb3f128e6.svg";